<div>
    <form #f="ngForm" [formGroup]="bryExtensionForm">
        <div [ngClass]="{'has-error' : (bryExtensionForm.get('certificate').touched && bryExtensionForm.get('certificate').hasError('invalid'))}"
            class="form-group col-md-12 mt-3 mb-4">
            <label for="select-certificado-list">{{ "signatureModal.digital.selectDesiredCertificate" | translate}}</label>
            <cdx-dropdown id="select-certificado-list" [options]="subscriberBryExtensionDropDown" [dropdownValid]="hasCertificateAvailable"  [disabled]="!hasCertificateAvailable"
                formControlName="certificate" (onSelectItem)="onDocumentSelected($event)">
            </cdx-dropdown>
            <cdx-helper *ngIf="!hasCertificateAvailable" [options]="helperNoCertificatesError"></cdx-helper>
            <div *ngIf="showAddExtension" class="mt-3">
                <button class="cdx-button cdx-button--secondary warning ml-0  col-md-12 responsive-width text-transform" (click)="installExtension()">
                    <span class="cdx-button__text">{{ 'bry.installSettings' | translate}}<span class="font-weight-bold ml-2 responsive-width">{{ 'bry.installSettingsAction' | translate}}</span></span>
                </button>

                <button *ngIf="isReloadExtension" class="cdx-button cdx-button--secondary info ml-0  col-md-12 responsive-width text-transform" (click)="reloadExtensionBry()">
                    <span class="cdx-button__text">{{ 'bry.updatePage' | translate}}<span class="font-weight-bold ml-2 responsive-width">{{ 'bry.updateAction' | translate}}</span></span>
                </button>
            </div>
        </div>
    </form>
</div>
